export const MenuHoverIcon = ({ ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="#292929"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.99984 21.3333C8.73622 21.3333 9.33317 20.7364 9.33317 20V13.3333C9.33317 12.597 8.73622 12 7.99984 12C7.26346 12 6.6665 12.597 6.6665 13.3333V20C6.6665 20.7364 7.26346 21.3333 7.99984 21.3333ZM18.6665 28C19.4029 28 19.9998 27.403 19.9998 26.6667V5.33333C19.9998 4.59695 19.4029 4 18.6665 4C17.9301 4 17.3332 4.59695 17.3332 5.33333V26.6667C17.3332 27.403 17.9301 28 18.6665 28ZM11.9998 22.6667C11.9998 23.403 12.5968 24 13.3332 24C14.0696 24 14.6665 23.403 14.6665 22.6667L14.6665 9.33333C14.6665 8.59695 14.0696 8 13.3332 8C12.5968 8 11.9998 8.59695 11.9998 9.33333V22.6667Z" />
    <path d="M22.6665 24C22.6665 24.7364 23.2635 25.3333 23.9998 25.3333C24.7362 25.3333 25.3332 24.7364 25.3332 24V8C25.3332 7.26362 24.7362 6.66667 23.9998 6.66667C23.2635 6.66667 22.6665 7.26362 22.6665 8V24Z" />
  </svg>
);
